<template>
  <div id="statistical">
    <div class="statisticalTitle" :style="activeStyle" @click="click" @mouseover="mouseover" @mouseout="mouseout">{{title}}</div>
    <div class="number">{{number}}</div>
  </div>
</template>

<script>
  export default {
    name: "Statistical",
    props:{
      title:{
        type: String
      },
      number:{
        type: Number
      },
      isActiveStyle:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        isMouseover:false
      }
    },
    computed:{
      activeStyle(){
        return this.isActiveStyle&&this.isMouseover?"color: #20a8d8;":""
        // return !this.isActive ? {"background-color":"black"} : {};
      }
    },
    methods: {
      open(){
        this.isActive = !this.isActive;
      },
      mouseover(){
        this.isMouseover = true
      },
      mouseout(){
        this.isMouseover = false
      },
      click(){
        if (this.isMouseover){
          this.$emit("goto")
        }
      }
    }
  }
</script>

<style scoped>
  #statistical{
    width: 200px;
  }

  .statisticalTitle{
    margin-top: 10px;
    font-size: 20px;
    font-weight: 300;
    text-align: center;
  }

  .number{
    margin-top: 10px;
    font-size: 30px;
    text-align: center;
  }
</style>
